import { createFileRoute } from '@tanstack/react-router'
import { ReportGenerationPage } from 'pages/reporting/ReportGenerationPage'
import { ReportRedirectPage } from 'pages/reporting/ReportRedirectPage'
import { ReportTemplateId } from 'pages/reporting/shared/reportTemplates'
import { z } from 'zod'

const reportSearchParams = z.object({
  templateId: z.nativeEnum(ReportTemplateId).optional(),
  metadataEntryId: z.string().optional(),
  section: z.string().optional(),
})

/**
 * Route component that renders either:
 * - ReportRedirectPage: when no templateId is in the URL (fetches metadata and redirects)
 * - ReportGenerationPage: when templateId is present (renders the report with the given template)
 */
const ReportRouteComponent = () => {
  const { templateId } = Route.useSearch()

  if (!templateId) {
    return <ReportRedirectPage />
  }

  return <ReportGenerationPage templateId={templateId} />
}

export const Route = createFileRoute('/reporting/$siteID/$reportID')({
  component: ReportRouteComponent,
  staticData: {
    title: 'Report',
    layout: {
      enableScrolling: true,
    },
  },
  validateSearch: reportSearchParams,
})
